import type { CardData } from './interfaces';

/**
 * Export summary data to CSV file
 *
 * @param summaryData - Object containing all summary sections to export
 * @param filename - Name of the CSV file (default: 'summary.csv')
 */
export const exportSummaryToCSV = (
  summaryData: {
    experimentInfo: {
      name?: string;
      date?: string;
    };
    immunoglobulinExpression: CardData[];
    antibodyClonotypes: CardData[];
    vGenes: CardData[];
    isotypes: CardData[];
    topMetrics: {
      totalCells?: number | string;
      cellsWithPairedVHVL?: number | string;
      antibodyClonotypes?: number | string;
    };
  },
  filename: string = 'summary.csv',
) => {
  filename = filename.replace(/[^a-zA-Z0-9-_.]/g, '_');
  const rows: string[][] = [];

  // Add top-level metrics section
  rows.push(['Experiment name', String(summaryData.experimentInfo.name ?? '--')]);
  rows.push(['Experiment date', String(summaryData.experimentInfo.date ?? '--')]);
  rows.push(['Total number of cells', String(summaryData.topMetrics.totalCells ?? '--')]);
  rows.push(['Number of cells with paired VH/VL', String(summaryData.topMetrics.cellsWithPairedVHVL ?? '--')]);
  rows.push(['Number of antibody clonotypes', String(summaryData.topMetrics.antibodyClonotypes ?? '--')]);
  rows.push([]);

  // Add V genes section
  rows.push(['V Genes', '']);
  summaryData.vGenes.forEach((item) => {
    const value = typeof item.value === 'number' || typeof item.value === 'string' ? String(item.value) : '--';
    rows.push([item.label, value]);
  });
  rows.push([]);

  // Add immunoglobulin expression section
  rows.push(['Immunoglobulin Expression', '']);
  summaryData.immunoglobulinExpression.forEach((item) => {
    const value = typeof item.value === 'number' || typeof item.value === 'string' ? String(item.value) : '--';
    rows.push([item.label, value]);
  });
  rows.push([]);

  // Add isotypes section
  rows.push(['Immunoglobulin Isotypes', '']);
  summaryData.isotypes.forEach((item) => {
    const value = typeof item.value === 'number' || typeof item.value === 'string' ? String(item.value) : '--';
    rows.push([item.label, value]);
  });

  // Convert rows to CSV format
  const csvContent = rows.map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(',')).join('\n');

  // Create and download the file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
